module.exports = __webpack_public_path__ + "img/swift-20210.e3fea59b.svg";